/**
 * Пометка тарифа у пункта поп-апа (#946).
 *
 * Пункт про возможность, которой на тарифе пользователя нет, НЕ скрывается:
 * человек должен узнать о том, чего у него нет, — это ровно тот случай, когда
 * новость работает на апгрейд. Вместо фильтра — подпись «доступно на Pro и
 * выше».
 *
 * Тариф читается из каталога возможностей, а не набирается руками в тексте
 * релиза: набранная руками подпись пережила бы следующее изменение тарифной
 * матрицы и осталась бы врать.
 */
import {
  PRODUCT_FEATURES_BY_ID,
  PRODUCT_PACKAGE_KEYS,
  type ProductPackageKey,
} from '@aica/core';

/**
 * Пакет, начиная с которого возможность включена, или null.
 *
 * null в двух разных случаях, и оба означают «подписи нет»: возможность
 * доступна на тарифе пользователя, либо каталог не знает такого id (гейт
 * `check:whats-new` этого не пропустит, но фронт не место для падения).
 *
 * `add_on`, `custom` и `internal` включением не считаются: «доступно на
 * Business» про то, что и там продаётся отдельно, — обещание, которого мы не
 * давали.
 */
export function tierNoteFor(
  featureId: string | undefined,
  tier: ProductPackageKey
): ProductPackageKey | null {
  if (!featureId) return null;

  const feature = PRODUCT_FEATURES_BY_ID[featureId];
  if (!feature) return null;
  if (feature.packages[tier] === 'included') return null;

  return PRODUCT_PACKAGE_KEYS.find((key) => feature.packages[key] === 'included') ?? null;
}
